/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateStockupItemRequestStockupItem
 */
export interface CreateStockupItemRequestStockupItem {
    /**
     * 
     * @type {number}
     * @memberof CreateStockupItemRequestStockupItem
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof CreateStockupItemRequestStockupItem
     */
    status: CreateStockupItemRequestStockupItemStatusEnum;
}


/**
 * @export
 */
export const CreateStockupItemRequestStockupItemStatusEnum = {
    Reserved: 'reserved',
    OutOfStock: 'out_of_stock'
} as const;
export type CreateStockupItemRequestStockupItemStatusEnum = typeof CreateStockupItemRequestStockupItemStatusEnum[keyof typeof CreateStockupItemRequestStockupItemStatusEnum];


/**
 * Check if a given object implements the CreateStockupItemRequestStockupItem interface.
 */
export function instanceOfCreateStockupItemRequestStockupItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "quantity" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function CreateStockupItemRequestStockupItemFromJSON(json: any): CreateStockupItemRequestStockupItem {
    return CreateStockupItemRequestStockupItemFromJSONTyped(json, false);
}

export function CreateStockupItemRequestStockupItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateStockupItemRequestStockupItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quantity': json['quantity'],
        'status': json['status'],
    };
}

export function CreateStockupItemRequestStockupItemToJSON(value?: CreateStockupItemRequestStockupItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quantity': value.quantity,
        'status': value.status,
    };
}

